<!--Can't use multiple ng-content in a component, so need to do this :-(-->
<ng-template #contentTemplate><ng-content></ng-content></ng-template>
<h3 class="type-subtitle-1" *ngIf="isLevel1" [class.zero-margin]="zeroMargin">
  <ng-template [ngTemplateOutlet]="contentTemplate"></ng-template>
</h3>
<h4 class="type-subtitle-2" *ngIf="!isLevel1" [class.zero-margin]="zeroMargin">
  <ng-template [ngTemplateOutlet]="contentTemplate"></ng-template>
</h4>
